/*
 * @Author: your name
 * @Date: 2021-04-14 10:47:13
 * @LastEditTime: 2021-04-30 10:40:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /me-short-version/src/utils/utils.js
 */
import store from "@/store/store.js";
export default {
    /**
     * 防抖函数
     * @param {function} fn
     * @param {time} delay 延迟时间默认500ms
     */
    debounce(fn, delay = 500) {
        //默认300毫秒
        let timer;
        return function() {
            let args = arguments;
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => {
                fn.apply(this, args);
            }, delay);
        };
    },

    /**
     * 整合图表数据结构
     */
    changeChartsDatas(data) {},
    /**
     * 深度遍历
     */
    deepTraversing(node, nodeList = [], key = "childList") {
        if (node !== null) {
            for (let i = 0; i < node.length; i++) {
                nodeList.push(node);
                let children = node[key];
                if (children && children.length > 0) {
                    this.format(children, nodeList);
                }
            }
        }
        return nodeList;
    },

    getFontColor() {
        let themeType = store.state.index.themecolor;

        // console.log('themeType: ', themeType);
        if (themeType == "default" || themeType == "green") {
            return "#898989";
        } else {
            return "#999999";
        }
    },
    handleTree(data, id, parentId, children) {
        let config = {
            id: id || 'id',
            parentId: parentId || 'parentId',
            childrenList: children || 'children'
        }

        var childrenListMap = {}
        var tree = []
        for (let d of data) {
            let id = d[config.id]
            childrenListMap[id] = d
            if (!d[config.childrenList]) {
                d[config.childrenList] = []
            }
        }

        for (let d of data) {
            let parentId = d[config.parentId]
            let parentObj = childrenListMap[parentId]
            if (!parentObj) {
                tree.push(d)
            } else {
                parentObj[config.childrenList].push(d)
            }
        }
        return tree
    }
};
